import UnauthenticatedItems from 'components/nav/unauthenticated/UnauthenticatedItems';

export default {
  default: UnauthenticatedItems,
};
